import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function ContactList({ contacts, selectedContact, setSelectedContact }) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRight: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: "0.8rem",
          borderBottom: "1px solid #ddd",
          fontWeight: "600",
          fontSize: "1.1rem",
          color: "#333",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <FaWhatsapp style={{ color: "#25D366" }} /> Conversas
      </div>

      <div style={{ overflowY: "auto", flex: 1 }}>
        {contacts.map((c) => (
          <div
            key={c.id}
            onClick={() => setSelectedContact(c)}
            style={{
              padding: "0.8rem 1rem",
              borderBottom: "1px solid #f2f2f2",
              backgroundColor: selectedContact?.id === c.id ? "#e9f5ee" : "#fff",
              cursor: "pointer",
              transition: "0.2s",
            }}
          >
            <div style={{ fontWeight: "600", color: "#111" }}>{c.name}</div>
            <div style={{ fontSize: "0.9rem", color: "#666" }}>{c.lastMessage}</div>
            <div style={{ fontSize: "0.75rem", color: "#999", textAlign: "right" }}>{c.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
